'use client';

import { Link } from '@coolblue-development/freddy';
import clickReviewsInWishlistTrigger from '@coolblue-development/ga4-events/triggers/Wishlist/clickReviewsInWishlistTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { ProductTitleReview } from '@coolblue-development/next-patterns/client';

type Props = {
  productId: number;
  href?: string;
  value: number;
  reviewCount?: number;
};

export default function TrackedProductReviews({ productId, href, value, reviewCount }: Props) {
  const { trackEvent } = useAnalytics();

  const handleTracking = () => {
    trackEvent(
      clickReviewsInWishlistTrigger({
        item_id: productId
      })
    );
  };

  return (
    <Link href={`${href}#product-reviews`} onClick={handleTracking}>
      <ProductTitleReview value={value} reviewCount={reviewCount} size='small' />
    </Link>
  );
}
